import moment from 'moment'
import Select from "react-select"
import React, { useState } from 'react'

import { stringifyDate, useListData, usePet } from "../../../modules"
import Receive from '../../../components/reusable/receive'

const Inventory = () => {
    const [string, setString] = useState()
    const [store, setStore] = useState()
    const [category, setCategory] = useState()
    const [selected, setSelected] = useState()
    const [stores, setStores] = useState([])
    const [ranges, setRanges] = useState([moment().startOf('day'), moment().endOf('day')])

    const [
        { loading: invLoading, error: invError, fetch }, 
        { list: inventory = [] }, 
        { navigate, Paginate, page = 1, limit = 10 }
    ] = useListData('inventory', {
        store: store?.value,
        category: category?.value !== 'All' ? category?.value : undefined,
        string
    }, { notify: true, manual: true }, 'inventory', 20)

    const [{ loading, error, fetch: fetchHistory }, 
        { list: history, data }, 
        { navigate: hNavigate, Paginate: hPaginate, page: hPage = 1, limit: hLimit = 100 }
    ] = useListData('itemHistory', ranges ? {
        id: selected?._id,
        store: store?.value,
        from: ranges[0]?._d ?? null, 
        to: ranges[1]?._d ?? null,
    } : {
        id: selected?._id,
        store: store?.value
    }, { notify: true, manual: true }, 'history')

    const refresh = () => {
        navigate(1)
        fetch()
    }

    const refreshHistory = () => {
        hNavigate(1)
        fetchHistory()
    }

    const selectStore = st => {
        setSelected()
        setStore(st)
        refresh()
    }

    const search = str => {
        setString(str)
        if (str?.trim().length > 1 || str.length === 0)
            refresh()
    }

    const selectItem = rec => {
        setSelected(rec)
        refreshHistory()
    }

    usePet('stores', { order: 1 }, { notify: true, callback: async ({ data }) => {
        setStores(data?.stores?.map(store => ({
            label: store.name,
            value: store._id
        })))

        let first = data?.stores[0]
        if (first)
            selectStore({
                label: first.name,
                value: first._id
            })
    } })

    return (
        <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto h-full overflow-hidden">
            <h2 className='text-xl font-semibold'>Inventory</h2>
            <div className="flex h-full overflow-hidden">
                <div className="w-1/3 overflow-y-scroll">
                    <div className="flex justify-between">
                        <input
                            onChange={ e => search(e.target.value) }
                            className="appearance-none block w-48 bg-gray-200 mr-2 text-gray-700 border border-gray-200 rounded py-3 px-4 leading-tight focus:outline-none focus:bg-white"
                            id="grid-inv-item"
                            type="text"
                            placeholder="Type to search items" />
                        <Select styles={{ input: styles => ({ ...styles, minWidth: '6em' }) }} label="Store" value={ store } onChange={ selectStore } options={ stores } />
                    </div>
                    {
                        store ?
                            <div className="overflow-x-auto">
                                <Receive
                                    error={invError}
                                    loading={invLoading}
                                    progress>
                                    {
                                        inventory?.length > 0 ?
                                            <table className="table-auto w-full">
                                                {/* Table header */}
                                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                    <tr>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">No</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Item</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Quantity</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center">Reorder Level</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-center"></div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {/* Table body */}
                                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                    {
                                                        inventory.map((rec, key) =>
                                                            <tr onClick={ () => selectItem(rec) } className={ rec?._id === selected?._id ? 'bg-gray-200 cursor-pointer' : 'cursor-pointer' }>
                                                                <td className="p-2">
                                                                    <div className="text-center">{ ((page - 1) * limit) + key + 1 }</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="">{rec.item.name}</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="text-center">{rec.variations.reduce((total, variant) => total + variant.total, 0)}</div>
                                                                </td>
                                                                <td className="p-2 text-center">
                                                                    20
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        :
                                            <div className="w-full h-16 flex items-center justify-center">
                                                <p className="font-semibold text-base">No items were found</p>
                                            </div>
                                    }
                                </Receive>
                                { Paginate }
                            </div>
                        :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">Please select a store</p>
                            </div>
                    }
                </div>
                <div className="w-2/3 px-3 overflow-y-scroll">
                    <h2 className='text-xl font-semibold'>Inventory Trail ({ selected?.item?.name })</h2>
                    {
                        selected ?
                            <>
                                <Receive
                                    error={error}
                                    loading={loading}
                                    progress>
                                    {
                                        history?.length > 0 ?
                                            <table className="table-auto w-full">
                                                {/* Table header */}
                                                <thead className="text-xs uppercase text-gray-400 bg-gray-50 rounded-sm">
                                                    <tr>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Date</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Amount</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Balance</div>
                                                        </th>
                                                        <th className="p-2">
                                                            <div className="font-semibold text-left">Description</div>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                {/* Table body */}
                                                <tbody className="text-sm font-medium divide-y divide-gray-100">
                                                    {
                                                        history.map((rec, key) =>
                                                            <tr>
                                                                <td className="p-2">
                                                                    <div className="text-left">{ stringifyDate(rec?.committedOn) }</div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="flex items-center mb-1">
                                                                        <div className={`${rec.bulkCount * rec.containing > 0 ? 'bg-green-500' : 'bg-red-500'} rounded-full h-4 w-4 border-gray-200 border-2 z-10`}>
                                                                        </div>
                                                                        <div className="flex-1 ml-4 font-medium">{rec.bulkCount * rec.containing} {selected?.issuedIn}</div>
                                                                    </div>
                                                                </td>
                                                                <td className="p-2">
                                                                    <div className="">{rec.total} {selected?.issuedIn}</div>
                                                                </td>
                                                                <td className="p-2 text-left">
                                                                    <div className="mb-1">
                                                                        <div className="font-semibold">Transacted By { rec?.committedBy?.name }</div>
                                                                        <div className="flex-1 ml-2 font-medium">{ rec.desc }</div>
                                                                    </div>
                                                                </td>
                                                            </tr>
                                                        )
                                                    }
                                                </tbody>
                                            </table>
                                        :
                                            <div className="w-full h-16 flex items-center justify-center">
                                                <p className="font-semibold text-base">No inventory trail was recorded for this item</p>
                                            </div>
                                    }
                                </Receive>
                                { hPaginate }
                            </>
                        :
                            <div className="w-full h-16 flex items-center justify-center">
                                <p className="font-semibold text-base">Please select an item</p>
                            </div>
                    }
                </div>
            </div>
        </div>
    )
}

export default Inventory